import _ from 'lodash'
import * as React from 'react'
import { Button, Card, CardBody, CardText } from 'reactstrap'

import { InputGroupFormat } from 'components/common/FormFormat/FormFormat'
import * as Rules from 'components/common/FormFormat/ValidationRules'
import { ColumnSizes } from 'components/common/utils'

import usePerformanceIndicesInput from 'hooks/usePerformanceIndicesInput'

export type PerformanceIndicesInputType = {
  [scheduleTypeId: string]: string | undefined
}

export type Props = {
  workerId?: number
  forecastColorScheduleTypeIds?: number[]
  onFocus?: (forecastColorScheduleTypeIds: number[]) => void
  performanceIndices: PerformanceIndicesInputType
  onChange: (performanceIndices: PerformanceIndicesInputType) => void
  initialPerformanceIndices?: PerformanceIndicesInputType
}
const PerformanceIndicesInput: React.FC<Props> = props => {
  const {
    performanceList,
    forecastPerformanceIndices,
    connectionTypeAutoExistsInTenant,
    forecastPerformanceIndicesDisabled,
    getBackgroundColor,
    onSetForecastPerformanceIndices,
    handleFocus,
    handleChange,
  } = usePerformanceIndicesInput(props)

  return (
    <Card>
      {connectionTypeAutoExistsInTenant && !forecastPerformanceIndicesDisabled && (
        <CardBody className="d-flex">
          <div className="flex-grow-1 align-self-center">過去実績最大30日の平均値を自動入力</div>
          <Button outline onClick={onSetForecastPerformanceIndices} disabled={_.isEmpty(forecastPerformanceIndices)}>
            過去実績から自動入力
          </Button>
        </CardBody>
      )}

      {performanceList.map(w => (
        <div key={w.workspaceId}>
          <hr className="m-0" />
          <CardBody>
            <CardText className="fw-bold">{w.name}</CardText>
            {w.scheduleTypes.map((s, i) => (
              <InputGroupFormat
                key={s.scheduleTypeId}
                value={props.performanceIndices[s.scheduleTypeId] || ''}
                maxLength={8}
                labelSize={ColumnSizes.middle}
                size={ColumnSizes.middle}
                label={s.name}
                addonText={`${s.unit || '-'}/時間`}
                onChange={value => handleChange(value, s)}
                backgroundColor={getBackgroundColor(s)}
                onFocus={() => handleFocus(s.scheduleTypeId)}
                validations={[Rules.PositiveInteger]}
                className={i === w.scheduleTypes.length - 1 ? '' : 'mb-3'}
              />
            ))}
          </CardBody>
        </div>
      ))}
    </Card>
  )
}

export default PerformanceIndicesInput
